export default "__VITE_ASSET__Dx89Deq8__"